import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ArrayVisualizer from './components/ArrayVisualizer';
import StackVisualizer from './components/StackVisualizer';
import QueueVisualizer from './components/QueueVisualizer';
import LinkedListVisualizer from './components/LinkedListVisualizer';
import TreeVisualizer from './components/TreeVisualizer'
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/array" element={<ArrayVisualizer />} />
        <Route path="/stack" element={<StackVisualizer />} />
        <Route path="/queue" element={<QueueVisualizer />} />
        <Route path="/linkedlist" element={<LinkedListVisualizer />} />
        <Route path="/tree" element={<TreeVisualizer />} />
        {/* Add more routes for other structures */}
      </Routes>
    </Router>
  );
}

export default App;
